<script>
import VehicleListingsBase from "@/components/VehicleListings/VehicleListingsBase.vue";

export default {
  name: "VehicleListingsBestDeals",
  extends: VehicleListingsBase,
  skipVehicleListingsAutoFetch: true, // We handle fetching ourselves after setting up filters
  mounted() {
    this.innerFilters = [
      {
        deal_score_phrase: {
          in: ["great", "excellent"]
        }
      }
    ];
    this.innerSorting = [{ deal_score: "desc" }];
    this.getVehicles();
  }
};
</script>
